export const customEvents = {
  navigation: {
    main: {
      open: 'navigationMainOpen',
      close: 'navigationMainClose',
    },
    secondary: {
      open: 'navigationSecondaryOpen',
      close: 'navigationSecondaryClose',
    },
    destinations: {
      open: 'navigationDestinationsOpen',
      close: 'navigationDestinationsClose',
    },
  },
};
